// @flow
import type {DeliveryMethodChoiceType} from '../../../modules/SignUp/DeliveryMethod/reducer';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {StyleSheet, View} from 'react-native';
import {ActivityIndicator, Text} from 'trpc-react-native-ui';
import {FlatList, FullButton, GradientPage} from '../../../components/common';
import {PageTitle} from '../../../components/signUp';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';
import {setDeliveryMethod} from '../../../modules/SignUp/DeliveryMethod';
import {isLoadingSelector} from '../../../modules/LoadingStatus/reducer';
import {deliveryGeolocationSelector} from '../../../modules/SignUp/DeliveryAddress';
import {
  deliveryMethodChoicesSelector,
  deliveryMethodSelector,
} from '../../../modules/SignUp/DeliveryMethod/selectors';
import config from '../../../config';
import Choice from './components/Choice';
import * as Navigation from '../../../lib/navigation.js';

import pageStyle from '../styles';

export class DeliveryMethod extends Component<Props> {
  styles = getStyles();

  submitForm = () =>
    Navigation.navigate({
      routeName: config.askPersonalInformationDuringOrderSim
        ? 'confirmPlan'
        : 'deliveryContact',
    });

  renderChoice = ({item: choice}: {item: DeliveryMethodChoiceType}) => {
    return (
      <Choice
        choice={choice}
        onSelect={this.onSelectChoice}
        selected={this.props.selectedChoice.id === choice.id}
      />
    );
  };

  onSelectChoice = (choice: DeliveryMethodChoiceType) =>
    this.props.setDeliveryMethod(choice.id);

  render() {
    const styles = this.styles;
    return (
      <GradientPage>
        <PageTitle
          title={I18n.t('SignUp.DeliveryMethod.title')}
          style={pageStyle.title}
        />
        {!this.props.geolocation && (
          <Text style={styles.noGeolocation}>
            {I18n.t('SignUp.DeliveryMethod.noGeolocation')}
          </Text>
        )}
        <View style={styles.form}>
          {this.props.isLoadingPremiumEligibility ? (
            <View style={styles.loadingContainer}>
              <ActivityIndicator color={theme.signUpTextColor} />
            </View>
          ) : (
            <View>
              <FlatList
                contentContainerStyle={styles.choicesContainer}
                renderItem={this.renderChoice}
                data={this.props.choices}
                keyExtractor={choice => choice.id}
                extraData={this.props.selectedChoice}
                showsVerticalScrollIndicator={false}
              />
            </View>
          )}
          <FullButton
            onPress={this.submitForm}
            text={I18n.t('SignUp.DeliveryMethod.confirmButton')}
            disabled={
              this.props.isLoadingPremiumEligibility ||
              !this.props.selectedChoice
            }
            testID={'deliveryMethodConfirmButton'}
          />
        </View>
      </GradientPage>
    );
  }
}

function getStyles() {
  return StyleSheet.create({
    form: {
      flex: 1,
      justifyContent: 'space-between',
      marginBottom: 30,
      marginHorizontal: 17,
    },
    loadingContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    choicesContainer: {
      paddingTop: 15,
    },
    noGeolocation: {
      marginHorizontal: 17,
      marginTop: 15,
    },
  });
}

type Props = {
  choices: DeliveryMethodChoiceType[],
  isLoadingPremiumEligibility: boolean,
  geolocation: any,
  selectedChoice: DeliveryMethodChoiceType,
  setDeliveryMethod: Function,
};

const mapStateToProps = state => ({
  isLoadingPremiumEligibility: isLoadingSelector(
    state,
    'checkPremiumEligibility',
  ),
  selectedChoice: deliveryMethodSelector(state),
  choices: deliveryMethodChoicesSelector(state),
  geolocation: deliveryGeolocationSelector(state),
});

const mapDispatchToProps = {
  setDeliveryMethod,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryMethod);
